'use client';
import { css, Global, Theme } from '@emotion/react';

const opacityToHex = (opacity: number) =>
  Math.round(opacity * 255).toString(16);

const styles = (theme: Theme) => css`
  html {
    font-size: 16px;

    ${theme.breakpoints.down('xl')} {
      font-size: 14px;
    }

    ${theme.breakpoints.down('md')} {
      font-size: 16px;
    }
  }

  body {
    background: ${theme.color.background};
  }

  * {
    -webkit-tap-highlight-color: transparent;
  }

  ::selection {
    color: ${theme.color.onYellow};
    background-color: ${theme.color.yellow};
  }

  ::-webkit-scrollbar {
    width: ${theme.size['0500']};
    height: ${theme.size['0500']};
  }

  ::-webkit-scrollbar-thumb {
    border-radius: ${theme.shape.corner.full};
    background: ${theme.color.onBackground}${opacityToHex(theme.opacity.semiTransparent)};
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${theme.color.onBackground}${opacityToHex(theme.opacity.faded)};
  }

  ::-webkit-scrollbar-thumb:active {
    background: ${theme.color.onBackground}${opacityToHex(theme.opacity.solid)};
  }
`;

export const GlobalStyles = () => <Global styles={styles} />;
